import { Sync as SyncIcon } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { DateLabel } from 'components';
import { TranslationNamespace } from 'i18n';
import { P2PProviderLastOrderData } from 'types';
import { formatUtils } from 'utils';

type Props = {
  data?: P2PProviderLastOrderData;
  disabled?: boolean;
  onLoad: () => void;
};

export const P2PProviderLastOrder: React.FC<Props> = ({
  data,
  disabled,
  onLoad,
}) => {
  const { t } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'pages.internal_wallets.resources',
  });

  const { t: tCommon } = useTranslation();

  return (
    <div className="tw-flex tw-items-center">
      {data && (
        <div className="tw-mr-1 tw-inline-grid tw-grid-cols-1 xl:tw-grid-cols-2 tw-gap-2">
          <div>{tCommon('common.payin')}</div>
          <DateLabel>
            {data.payinLastTakenOrderAt
              ? formatUtils.formatDate(data.payinLastTakenOrderAt)
              : '-'}
          </DateLabel>
          <div>{tCommon('common.payout')}</div>
          <DateLabel>
            {data.payoutLastTakenOrderAt
              ? formatUtils.formatDate(data.payoutLastTakenOrderAt)
              : '-'}
          </DateLabel>
        </div>
      )}
      <Tooltip title={data ? t('refresh') : t('fetch')}>
        <IconButton
          color="primary"
          disabled={disabled}
          onClick={(e) => {
            e.stopPropagation();
            onLoad();
          }}
        >
          <SyncIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
};
